<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <el-row class="searchForm" :gutter="10">
            <el-col :span="8">
              区域类型：
              <el-select
                v-model="searchData.country_type"
                title="请选择"
                @change="clearCountry"
                filterable
                clearable>
                <el-option
                  v-for="option in constDict.country_type_list"
                  :key="option.id"
                  :label="option.value"
                  :value="option.id"/>
              </el-select>
            </el-col>
            <el-col :span="8">
              国家地区：
              <el-select
                v-model="searchData.country_id"
                title="请选择"
                multiple
                filterable
                clearable>
                <el-option
                  v-for="option in constDict.country_list"
                  v-if="option.pid === searchData.country_type"
                  :key="option.id"
                  :label="option.value"
                  :value="option.id"/>
              </el-select>
            </el-col>
            <el-col :span="8">
              推广人：
              <el-select
                filterable
                v-model="searchData.custom_promoter"
                multiple
                clearable
                placeholder="请选择">
                <el-option-group
                  v-for="(group, k) in constDict.view_users"
                  :key="k"
                  :label="group.label">
                  <el-option
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
                </el-option-group>
              </el-select>
            </el-col>
          </el-row>
          <el-row class="searchForm" :gutter="10">
            <el-col :span="8">
              转化时间：
              <el-date-picker
                v-model="searchData.timeline"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd">
              </el-date-picker>
            </el-col>
            <el-col :span="8">
              排序：
              <el-select v-model="searchData.sort" title="请选择" filterable clearable>
                <el-option key="count_all" label="资源数" value="count_all"/>
                <el-option key="sign_month" label="实际签约数" value="sign_month"/>
                <el-option key="sign_p" label="实际转化率" value="sign_p"/>
                <el-option key="sign_month_real" label="当期签约数" value="sign_month_real"/>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="searchBottom">
              <el-button class="jm-input-common3" type="primary" @click="init()">搜索</el-button>
            </el-col>
          </el-row>
          <div class="channel-list2020">
            <el-row class="list-title">
              <el-col :span="5">渠道名</el-col>
              <el-col :span="3">资源数</el-col>
              <el-col :span="3">公海资源数</el-col>
              <el-col :span="3">实际签约数</el-col>
              <el-col :span="3">实际转化率</el-col>
              <el-col :span="3">当期签约数</el-col>
              <el-col :span="3">星图拉取签约数</el-col>
            </el-row>
            <data-list :url="url"
                       @tapEvent="showChannelInfo"
                       :search-data="searchData"
                       :refresh.sync="refresh"
                       :refresh-lock="true">
              <template slot-scope="{ item, index, header, refresh }">
                <el-row class="channel-list-level channel-list-level1">
                  <el-col class="ib" :span="5"><span><i :class="item.show ? 'active' : ''" v-if="item.list"></i>{{ item.channel_name }}</span></el-col>
                  <el-col class="ib" :span="3">{{ item.count_all }}</el-col>
                  <el-col class="ib" :span="3">{{ item.water }}</el-col>
                  <el-col class="ib" :span="3">{{ item.sign_month_real }}</el-col>
                  <el-col class="ib" :span="3">{{ item.sign_p }}</el-col>
                  <el-col class="ib" :span="3">{{ item.sign_month }}</el-col>
                  <el-col class="ib" :span="3">{{ item.pullsign }}</el-col>
                </el-row>
                <div v-show="item.show" v-if="item.list">
                  <el-row class="channel-list-level channel-list-level2" v-for="ii in item.list" :key="ii.custom_from_sub">
                    <el-col class="ib" :span="5"><span>{{ ii.channel_name_str !== '' ? ii.channel_name_str : ii.custom_from_sub }}</span></el-col>
                    <el-col class="ib" :span="3">{{ ii.count_all }}</el-col>
                    <el-col class="ib" :span="3">{{ ii.water }}</el-col>
                    <el-col class="ib" :span="3">{{ ii.sign_month_real }}</el-col>
                    <el-col class="ib" :span="3">{{ ii.sign_p }}</el-col>
                    <el-col class="ib" :span="3">{{ ii.sign_month }}</el-col>
                    <el-col class="ib" :span="3">{{ ii.pullsign }}</el-col>
                  </el-row>
                </div>
              </template>
            </data-list>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BiBarLine from '@/components/charts/biBarLine';
import { getAdvisoryTeachers } from '@/api/teacher';
import jmTableList from '@/components/data/tableList';
import common from '@/pages/bi/common';
import { jmChannel } from '@/components/tool';
import dataList from '@/pages/h5/compoments/dataList';

let constDict = {
  year: ['全部'],
  month: ['全部', '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
};

export default {
  mixins: [common],
  data() {
    return {
      constDict,
      chartsData: {
        refresh: 1
      },
      chartsSort: {
        options: [],
        value: '资源数'
      },
      refresh: false,
      searchData: {
        timeline: [],
        custom_promoter: [],
        sort: 'count_all',
        country_type: '',
        country_id: []
      },
      url: '/index/b_i_mark_center_channel/getChannelPage',
      searchDsUrl: '/index/b_i_mark_center_channel/index',
    };
  },
  components: {
    BiBarLine, getAdvisoryTeachers, jmChannel, jmTableList, dataList
  },
  created() {
    this.$http
      ._get({
        url: this.searchDsUrl
      })
      .then(({ data }) => {
        this.constDict = Object.assign({}, this.constDict, data);
        this.searchData.roleid = typeof this.constDict.roleids === 'object' ? this.constDict.roleids[0].roleid : this.constDict.roleids;
        this.setSearchTime();
        this.init();
      });
  },
  methods: {
    init() {
      this.refresh = true;
    },
    showChannelInfo(item) {
      item.show = !item.show;
    },
    filterTeacher(option) {
      let group = (this.searchData.gid && this.searchData.gid === option.group_id) || !this.searchData.gid;
      let roleid = (this.searchData.roleid && this.searchData.roleid === option.role_id) || !this.searchData.roleid;
      return group && roleid;
    },
    setSearchTime() {
      let date = new Date();
      let dateNow = date.toLocaleDateString();
      let startMonth = dateNow.replace(RegExp('([0-9]+)$', ''), '');
      dateNow = dateNow.replace(RegExp('/', 'g'), '-');
      startMonth = startMonth.replace(RegExp('/', 'g'), '-');
      this.searchData.timeline = [`${startMonth}1`, dateNow];
    },
    clearCountryType() {
      this.searchData.country_type = '';
      this.clearCountry();
    },
    clearCountry() {
      this.searchData.country_id = [];
    }
  },
  watch: {
  }
};

</script>

<style scoped>
.searchForm *{
  padding: 5px;
}

.channel-list2020 .list-title {
  background: #01142d;
  line-height: 40px;
  color: #fff;
  text-align: center;
}
.channel-list2020 .channel-list-level {
  line-height: 40px;
}
.channel-list2020 .channel-list-level:hover {
  background: #e6ebf6;
}
.channel-list2020 .channel-list-level1 .ib{
  border-left: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
}

.channel-list2020 .channel-list-level1 .ib span{
  padding-left: 30px;
}
.channel-list2020 .channel-list-level span:nth-of-type(1) i{
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translateY(-50%);
  border-top: 6px solid red;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  transition: all linear 0.2s;
}
.channel-list2020 .channel-list-level span:nth-of-type(1) i.active{
  transform: translateY(-50%) rotate(180deg);
}
.channel-list2020 .channel-list-level2 {
  background: #eff2f9;
  color: #000;
}
.channel-list2020 .channel-list-level2 .ib{
  border-top: 1px solid #d9dfed;
  border-left: 1px solid #d9dfed;
}
.channel-list2020 .channel-list-level2 .ib:last-child{
  border-right: 1px solid #d9dfed;
}
.channel-list2020 .channel-list-level2 .ib span{
  padding-left: 50px;
}
.channel-list2020 /deep/ .infinite-list-wrapper ul li{
  background: #fff;
  color: red;
  border-radius: 0;
  margin-bottom: 0;
  padding: 0;
}
</style>
